module.exports = __webpack_public_path__ + "static/media/noWebResource.1c4d237c.svg";